export default "__VITE_ASSET__umgrglCo__"